import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../../services/apirest";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  Box,
  Stack,
  TextField,
  Snackbar,
  Alert,
  DialogTitle,
  Typography,
  Grid,
  Autocomplete,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { getData } from "../../../../../services/library";

function EdicionGrupo(props) {
  const [editar, setEditar] = useState(props.editar);
  const [datosRow, setDatosRow] = useState(props.datosRow);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [disbtn, setdisbtn] = useState(false);
  const [provincias, setProvincias] = useState();
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState("");
  const [localidades, setLocalidades] = useState();
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [buscando, setBuscando] = useState(false);

  useEffect(() => {
    getData("/provincias", setProvincias);
  }, []);

  useEffect(() => {
    getData("/localidades/prov/" + provinciaSeleccionada?.id, setLocalidades);

    if (!(datosRow.id_provincia === provinciaSeleccionada.id)) {
      setLocalidadSeleccionada("");
    }
    setBuscando(false);
  }, [datosRow.id_provincia, provinciaSeleccionada]);

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const handleClose = () => {
    setEditar(!editar);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

  const EditarGrupo = async (e) => {
    setdisbtn(true);
    e.preventDefault();
    await fetch(UrlApi + "/envasado_grupos_zonas/" + datosRow.id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nombre: datosRow.nombre,
        descripcion: datosRow.descripcion,
        localidad: localidadSeleccionada.id,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setColorMensaje("#D4EFDF");
          setMensaje("El Grupo se editó exitosamente !");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al editar el Grupo");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

    useEffect(() => {
      // provincia
      if (datosRow.id_provincia !== "" && provincias) {
        const provinciaEncontrada = provincias.find(
          (d) => d.id === datosRow.id_provincia
        );
        if (provinciaEncontrada) {
          setProvinciaSeleccionada(provinciaEncontrada);
        }
      }
    }, [provincias]);
  
    useEffect(() => {
      // localidad
      if (datosRow.localidad && localidades?.length) {
        const localidadEncontrada = localidades.find(
          (d) => d.id === Number(datosRow.localidad)
        );
  
        if (localidadEncontrada) {
          setLocalidadSeleccionada(localidadEncontrada);
        }
      }
    }, [localidades]);
  

  return (
    <>
      <Dialog
        fullWidth
        open={editar}
        onClose={() => handleClose()}
        maxWidth="xl"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Editar Grupo {datosRow.id}
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={EditarGrupo}>
          <DialogContent>
            {/* <Box
              backgroundColor="#F4F6F6"
              px={2}
              py={2}
              border={0.5}
              borderColor={"#ABB2B9"}
              borderRadius={3}
            > */}
              <Grid container spacing={1}>
                <Grid item xs={3} py={1} mb={1}>
                  <TextField
                    label="Nombre"
                    name="nombre"
                    size="small"
                    placeholder="..."
                    inputProps={{
                      maxLength: 100,
                    }}
                    focused
                    required
                    fullWidth
                    value={datosRow.nombre}
                    onChange={almacenar}
                  />
                </Grid>
                <Grid item xs={9} py={1} mb={1}>
                  <TextField
                    label="Descripción"
                    name="descripcion"
                    size="small"
                    placeholder="..."
                    inputProps={{
                      maxLength: 300,
                    }}
                    focused
                    required
                    fullWidth
                    value={datosRow.descripcion}
                    onChange={almacenar}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    disabled={!provincias}
                    required
                    disableClearable
                    id="provincia"
                    // style={style}
                    size={"small"}
                    noOptionsText={"Provincia INEXISTENTE"}
                    options={provincias}
                    autoHighlight
                    getOptionLabel={(provincia) =>
                      provincia.id + "-" + provincia.provincia
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={provinciaSeleccionada || null}
                    defaultValue={provinciaSeleccionada || null}
                    onChange={(event, value) => {
                      setProvinciaSeleccionada(value);
                      setBuscando(true);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.id} - {option.provincia}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar..."
                        {...params}
                        focused
                        required
                        label="Provincia"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  {buscando === true ? (
                    <TextField
                      disabled
                      focused
                      fullWidth
                      size={"small"}
                      label="Buscando Localidades..."
                    />
                  ) : (
                    <Autocomplete
                      disabled={!localidades}
                      required
                      disableClearable
                      id="localidad"
                      name="id_localidad"
                      // style={style}
                      size={"small"}
                      noOptionsText={"Localidad INEXISTENTE"}
                      options={localidades}
                      autoHighlight
                      // getOptionLabel={(localidad) =>
                      //   localidad.id + "-" + localidad.localidad
                      // }
                      getOptionLabel={(localidad) =>
                      localidad.cp + " - " + localidad.localidad  // Cambiado: muestra CP en lugar de ID
                    }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value?.id
                      }
                      defaultValue={localidadSeleccionada || null}
                      value={localidadSeleccionada || null}
                      onChange={(event, value) => {
                        setLocalidadSeleccionada(value);
                      }}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {/* {option.id} - {option.localidad} */}
                          {option.cp} - {option.localidad} 
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Tipee para buscar..."
                          {...params}
                          focused
                          required
                          label="Localidad"
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                mt={1}
              >
                <Grid item>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={() => handleClose()}
                    style={{ backgroundColor: "#fff" }}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    color="success"
                    variant="contained"
                    disabled={disbtn}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            {/* </Box> */}
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default EdicionGrupo;
